export default __webpack_public_path__ + "static/media/9.dc809ff5.png";